import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-0460fe48"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "tooltip",
  class: "tooltip-calendar"
}, " Вы можете выбрать дату минимум через неделю от текущей даты. ", -1))

import Calendar from "primevue/calendar";
import { dayWeekBefore } from "@/services/utils/DateValidator";


export default /*#__PURE__*/_defineComponent({
  __name: 'CalendarInput',
  props: ["modelValue", "disabled"],
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {


const emit = __emit;

const onCalendarShow = () => {
  createCalendarTooltips();
};

const onMonthChanged = () => {
  setTimeout(() => {
    createCalendarTooltips();
  }, 500);
};

const onCloseCalendar = () => {
  const elems = document.querySelectorAll(".tooltip-calendar");
  elems.forEach((element) => {
    if (element instanceof HTMLElement) {
      element.style.display = "none";
    }
  });
};

const createCalendarTooltips = () => {
  const elems = document.querySelectorAll(
    "td[data-pc-group-section='tablebodycell'] span.p-disabled"
  );
  elems.forEach((element) => {
    if (element instanceof HTMLElement) {
      element.addEventListener("click", (event: MouseEvent) => {
        showTooltip(
          event,
          "Вы не можете выбрать дату позднее чем неделя назад от текущей даты."
        );
      });
      element.style.pointerEvents = "all";
    }
  });
};

function showTooltip(event: MouseEvent, message: string) {
  const tooltip = document.getElementById("tooltip");
  if (tooltip) {
    tooltip.innerText = message;
    tooltip.style.left = `${event.pageX + 15}px`;
    tooltip.style.top = `${event.pageY + 15}px`;
    tooltip.style.display = "block";
    setTimeout(() => {
      tooltip.style.display = "none";
    }, 3000);
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(Calendar), {
      id: "date",
      placeholder: "Выберите дату",
      panelClass: "not-extended",
      "model-value": __props.modelValue,
      "aria-describedby": "date-help",
      showIcon: "",
      iconDisplay: "input",
      inputId: "icondisplay",
      "max-date": _unref(dayWeekBefore)(),
      disabled: __props.disabled,
      selectOtherMonths: true,
      onShow: _cache[0] || (_cache[0] = ($event: any) => (onCalendarShow())),
      onHide: _cache[1] || (_cache[1] = ($event: any) => (onCloseCalendar())),
      onMonthChange: _cache[2] || (_cache[2] = ($event: any) => (onMonthChanged())),
      "onUpdate:modelValue": _cache[3] || (_cache[3] = 
      ($event) => {
        emit('update:modelValue', $event)
      }
    )
    }, null, 8, ["model-value", "max-date", "disabled"]),
    _hoisted_1
  ], 64))
}
}

})